import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { tooltipHide } from '../../../actions/tooltipActions';

// components
import { Button } from '../../shared/_form';
import Modal from '../../shared/_Modal';
import { acceptTradeOffer } from '../../../actions/tradeOffersActions';

class AcceptTradeRequestModal extends React.Component {
    _handleHideModal = () => {
      const { hideTooltip, id } = this.props;

      hideTooltip(id);
    };

    _handleAcceptTradeOffer = () => {
      const { tradeOfferId, tradeOfferAccept } = this.props;

      tradeOfferAccept(tradeOfferId);
    };

    componentWillUnmount() {
      this._handleHideModal();
    }

    render() {
      const { id } = this.props;

      return (
        <Modal id={ id }>
          <div className='modal__header'>
                    Are you sure?
          </div>

          <div>
                    Are you sure you want to accept this trade request?
          </div>

          <div className='modal__actions'>
            <Button className='form__button form__button--purple'  onClick={ this._handleAcceptTradeOffer } type='button'>Yes</Button>
            <Button className='form__button form__button--green' onClick={ this._handleHideModal } type='button'>No</Button>
          </div>
        </Modal>
      );
    }
}

AcceptTradeRequestModal.propTypes = {
  hideTooltip: PropTypes.func.isRequired,
  id: PropTypes.string,
  tradeOfferAccept: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideTooltip: (id) => dispatch(tooltipHide({ id })),
    tradeOfferAccept: (tradeOfferId) => dispatch(acceptTradeOffer({ tradeOfferId }))
  };
};

export default connect(null, mapDispatchToProps)(AcceptTradeRequestModal);



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/AcceptTradeRequestModal.jsx